import axios from 'axios';
import { AUTH_TOKEN_KEY, UNAUTHENTICATED_API_PATHS, handleSessionExpired } from '../utilities/auth';

// Mirrors the grace window HeaderStyle/header.js already uses around its own
// profile-details bootstrap call: right after a page load/refresh the token
// can briefly 401 while auth state settles server-side, so we don't want to
// force a logout for that. After the grace window, any 401 on a request that
// carried the auth token means the token really is invalid/expired.
const APP_LOADED_AT = Date.now();
const AUTH_SETTLE_GRACE_MS = 45000;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const hadAuthToken = !!error?.config?.headers?.['x-auth-token'];
    const isUnauthenticatedEndpoint = UNAUTHENTICATED_API_PATHS.some((path) => requestUrl.includes(path));
    const withinSettleGrace = Date.now() - APP_LOADED_AT < AUTH_SETTLE_GRACE_MS;

    if (status === 401 && hadAuthToken && !isUnauthenticatedEndpoint && !withinSettleGrace && localStorage.getItem(AUTH_TOKEN_KEY)) {
      handleSessionExpired();
    }

    return Promise.reject(error);
  }
);
